/**
 * Copy to Clipboard button w/ tooltip.
 *
 * This is useful with AlpineJS, since you can plug this into an x-init pretty easily and give a whole bunch of stuff in
 * Livewire click-to-copy functionality without needing to worry about re-rendering the component and setting all the
 * behaviours up again.
 *
 * Here's an example:
 *
 *         <button
 *             x-data="{}"
 *             x-init="$nextTick(() => { NUCopyButton($el, 'Share URL copied to clipboard!') })"
 *             id="copyButton"
 *             data-clipboard-text="https://this-is-what-gets-copied.northwestern.edu"
 *             data-tooltip-success-target="copyButton"
 *             class="btn btn-outline-secondary"
 *             type="button"
 *         >
 *             <i class="fas fa-paste" aria-hidden="true"></i>
 *             Copy URL
 *         </button>
 *
 * You can adjust the data-tooltip-success-target attribute to attach the tooltip to something else. This might be
 * necessary if your click-to-copy button is in a dropdown menu; once they click, the menu will close, so attaching
 * the tooltip to the element inside the now-hidden dropdown isn't gunna do anything useful -- you'd want to attach it
 * to the dropdown menu itself in that case!
 */

window.NUCopyButton = (element, tooltipText) => {
    var clipboard = new ClipboardJS(element);

    clipboard.on('success', function (e) {
        const actionsDropdown = $($(e.trigger).data('tooltip-success-target'));
        const tooltipOpts = { title: tooltipText, trigger: 'manual' };
        const tooltip = actionsDropdown.tooltip(tooltipOpts);

        setTimeout(function () {
            actionsDropdown.tooltip('hide').tooltip('dispose');
        }, 1500);

        tooltip.tooltip('show');
    });
};

